import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@vectord/styles';
import { Provider } from 'react-redux';
import { RecoilRoot } from 'recoil';

import { AppRoutes } from 'AppRoutes';
import './App.module.scss';
import TrackingBase from 'components/TrackingBase/TrackingBase';
import DEFAULT_THEME from 'data/defaultTheme';
import store from 'store';
import WithAuth from 'components/WithAuth';
import WithUserRoles from 'components/WithUserRoles';

function App() {
  return (
    <Provider store={store}>
      <RecoilRoot>
        <ThemeProvider theme={DEFAULT_THEME}>
          <WithAuth>
            <TrackingBase>
              <WithUserRoles>
                <RouterProvider router={AppRoutes} />
              </WithUserRoles>
            </TrackingBase>
          </WithAuth>
        </ThemeProvider>
      </RecoilRoot>
    </Provider>
  );
}

export default App;
